import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const header = (isStorefronts: boolean, hasCompactSpacing: boolean) => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 ${isStorefronts ? "0" : "2rem"} ${hasCompactSpacing ? "0" : "2rem"};
  margin-top: 3.5rem;

  margin: auto;
  max-width: 34rem;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    margin-top: 1.5rem;
  }
`;
